import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

//convert to specific timezone
export const convertToTimezone = (date) => {
    const timezone = dayjs.tz.guess();
    return dayjs(date).tz(timezone).toDate();
};

//format date into a dayjs object
export const formatCurrentDate = (date, format) => {
    return dayjs(date).format(format);
};

//parse date from a string
export const parseISODate = (isoString) => {
    return dayjs(isoString).toDate();
};

// Converts to UTC and returns ISO string
export const toISOString = (date) => {
    return dayjs(date).utc().toISOString();
};

// check current date is before given date
export const isBeforeDate = (date) => {
    const dateInMilliseconds = date * 1000;
    return dayjs().isBefore(dayjs.utc(dateInMilliseconds));
}

// Converts a Unix seconds timestamp to the midnight (00:00:00) of that date, in UTC.
export const getMidnightOfExpiry = (timestampInSeconds) => {
    if (!timestampInSeconds) {
        return null;
    }
    const dateInMilliseconds = timestampInSeconds * 1000;

    return dayjs.utc(dateInMilliseconds).local().endOf('day');
};